/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
var MedHelmet = function (quality) {
  return {
    slot: 'helmet',
    type: 'med',
    quality: quality,
    armorClass: Math.round(6 + quality * 36),
    perception: Math.round(2 + quality * 4),
  };
};
module.exports = MedHelmet;
